import React from "react";
import { observer, inject } from "mobx-react";
import { orderBy } from "lodash";
import { ReviewsLayout } from "ComponentsUI/Reviews";
import Button from "ComponentsUI/Button";
import Block from "ComponentsUI/Block";
import { Link, withRouter } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";

var Routes = require("Configs/routes");
import { graphql } from "@apollo/client/react/hoc";
import { REVIEWS_PROVIDER_CARD } from "Services/queries";
import withDefaultParams from "Services/withDefaultParams";
import withStyles from "react-jss";
import classNames from "classnames";
import AllTariffsButton from "./AllTariffsButton";

const styles = (theme) => ({
	btnAllReviews: {
		display: "none",
	},
	btnRatingLeaveReview: {
		display: "block",
	},
	btnRatingLeaveReviewSecond: {
		display: "none",
	},
	btnAllTariffs: {
		display: "block",
	},
	buttonsContainer: {
		position: "relative",
		maxWidth: "1180px",
		margin: "0 auto",
	},
	buttonsWrapper: {
		display: "flex",
		position: "absolute",
		bottom: "-50px",
		right: "0px",
	},
	headerButton: {
		width: "auto",
		marginRight: "20px",
		color: theme.palette.colors.purplishBlue,
		"&:last-child": {
			marginRight: 0,
		},
	},
	[`@media (max-width: ${theme.media.lg})`]: {
		buttonsContainer: {
			maxWidth: "940px",
			margin: "0 auto",
		},
	},
	[`@media (max-width: ${theme.media.md})`]: {
		buttonsContainer: {
			maxWidth: "710px",
			margin: "0 auto",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		btnRatingLeaveReviewSecond: {
			display: "block",
		},
		btnAllTariffs: {
			display: "none",
		},
		btnAllReviews: {
			display: "block",
		},
		btnRatingLeaveReview: {
			display: "none",
		},
		buttonsWrapper: {
			display: "none",
		},
	},
});

@inject("ApplicationModel")
@observer
class Reviews extends React.Component {
	onClickButtonHandler() {
		this.props.ApplicationModel.providerModel.setProviderFeedback(
			this.props.match.params.providerName
		);
	}

	showTariffHandler() {
		let providerModel = this.props.ApplicationModel.providerModel;
		providerModel.changeTab("provider_tab_tariffs");
	}

	render() {
		let isStub = !this.props.data.reviewsProviderCard;
		let text = this.props.ApplicationModel.text;
		let reviews = [null, null, null, null];
		let feedbackUrl = null;
		let providerReviewsUrl = null;
		let classes = this.props.classes;
		let textHeader = text.REVIEWS_FROM_PROVIDERS;
		let provider = this.props.providerForCard;

		if (!isStub) {
			reviews = this.props.data.reviewsProviderCard.data;

			if (!reviews.length) {
				return null;
			}

			if (reviews.some((x) => x?.real)) {
				textHeader = text.REVIEWS_FROM_USERS;
				reviews = reviews.filter((x) => x?.real);
			}

			feedbackUrl = generateUrl(Routes.AddReview.route, {
				regionUrl: this.props.match.params.regionUrl,
			});
			providerReviewsUrl = generateUrl(Routes.ProvidersReviewListOld.route, {
				regionUrl: this.props.match.params.regionUrl,
				providerName: this.props.match.params.providerName,
			});
		}

		let windowSizesModel = this.props.ApplicationModel.windowSizeModel;
		let cut = windowSizesModel.windowSizes.lg ? 8 : windowSizesModel.windowSizes.sm ? 4 : 6;
		// if (windowSizesModel.windowSizes.sm) {
		//     cut = 4;
		// }

		if (cut !== 8 && reviews.length !== 0) {
			const neutralReviews = reviews.filter((x) => x?.rating_type === "neutral");
			if (neutralReviews.length > 1) {
				reviews = reviews.filter((x) => x.id !== neutralReviews[0].id);
			}
		}

		reviews = reviews.slice(0, cut);

		if (windowSizesModel.windowSizes.xs || windowSizesModel.windowSizes.sm) {
			reviews = orderBy(reviews, ["date"], ["desc"]);

			if (reviews[0]?.rating_type !== "positive") {
				const idx = reviews.findIndex((x) => x?.rating_type === "positive");

				if (idx !== -1) {
					reviews = [].concat(reviews.splice(idx, 1), reviews);
				}
			}
		}

		if (reviews.length > 0) {
			return (
				<Block
					stub={isStub}
					header={textHeader}
					headerWithoutMargin={true}
					btn={
						<div>
							<div className={classes.btnAllReviews}>
								<Button
									stub={isStub}
									typeText="big"
									component={<Link to={!!providerReviewsUrl ? providerReviewsUrl : "/"} />}
									size={"middle"}
									datatest="providers_provider_allreviews_button"
									status={"purple"}
									fullWidth={true}
								>
									{text.reviewsAll}
								</Button>
							</div>
							<div className={classes.btnRatingLeaveReview}>
								<Button
									stub={isStub}
									typeText="big"
									component={<Link to={!!feedbackUrl ? feedbackUrl : "/"} />}
									size={"middle"}
									status={"tertiaryAccent"}
									datatest="main_allreviews_button"
									fullWidth={true}
									onClick={() => this.onClickButtonHandler()}
								>
									{text.ratingLeaveReview}
								</Button>
							</div>
						</div>
					}
					secondButton={
						<div>
							<div className={classes.btnRatingLeaveReviewSecond}>
								<Button
									stub={isStub}
									typeText="big"
									component={<Link to={!!feedbackUrl ? feedbackUrl : "/"} />}
									size={"middle"}
									status={"tertiaryAccent"}
									datatest="main_allreviews_button"
									fullWidth={true}
									onClick={() => this.onClickButtonHandler()}
								>
									{text.ratingLeaveReview}
								</Button>
							</div>
							{provider?.info?.cnt_tariffs ? <AllTariffsButton /> : null}
						</div>
					}
					services={true}
				>
					<div className={classes.buttonsContainer}>
						<ReviewsLayout stub={isStub} useCarusel={true} items={reviews} withoutPaddings={true} />
						<div className={classes.buttonsWrapper}>
							<div className={classNames(classes.headerButton, "onlyNotXs")}>
								<Button
									stub={isStub}
									typeText="big"
									component={<Link to={!!providerReviewsUrl ? providerReviewsUrl : "/"} />}
									size={"middle"}
									datatest="providers_provider_allreviews_button"
									status={"tertiaryAccent"}
									fullWidth={true}
								>
									{text.reviewsAll}
								</Button>
							</div>
						</div>
					</div>
				</Block>
			);
		} else {
			return null;
		}
	}
}

export default withRouter(
	withDefaultParams(
		graphql(REVIEWS_PROVIDER_CARD, {
			options: (props) => {
				return {
					variables: {
						filter: `region.url=${props.match.params.regionUrl}&provider.url_name=${props.match.params.providerName}`,
						providerJoin: true,
					},
				};
			},
		})(withStyles(styles)(Reviews))
	)
);
